import { msg } from '@lingui/core/macro'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { SprintList } from '~/components/tasks/sprint-list'
import { titleFor } from '~/lib/route-title'
import { useWorkspace } from '~/lib/workspace-context'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/sprints')({
  component: Sprints,
  head: () => ({ meta: [{ title: titleFor(msg`Sprints`) }] }),
})

function Sprints() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useWorkspace()
  // Sprints is a per-workspace feature gate — with it off the sidebar hides
  // the entry, so a direct URL is the only way here. Bounce to Tasks.
  if (workspace.sprintsEnabled !== true) {
    return <Navigate params={{ workspaceSlug }} replace to="/$workspaceSlug/tasks" />
  }
  return <SprintList />
}
